import { useQuery } from '@tanstack/react-query';
import { getConfig, ConfigurationObject } from '../services/configs-api';

/**
 * TanStack Query hook for fetching a single configuration object by configId.
 */
export function useConfig(configId: string | undefined) {
  return useQuery<ConfigurationObject>({
    queryKey: ['configs', configId],
    queryFn: () => getConfig(configId!),
    enabled: !!configId,
  });
}
